import { render } from "./AboutPage.vue?vue&type=template&id=6e7e6704&scoped=true&ts=true"
import script from "./AboutPage.vue?vue&type=script&lang=ts"
export * from "./AboutPage.vue?vue&type=script&lang=ts"

import "./AboutPage.vue?vue&type=style&index=0&id=6e7e6704&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7e6704"]])

export default __exports__